import { withLazy } from 'app/hocs/withLazy'

export const AuthResetPassword = withLazy(
  () => import('features/Auth/components/AuthResetPassword/AuthResetPassword'),
)
